import api from './common.js';

export default{
  // Обновление заказа
  // payload {
  //   id: 3,
  //   data:{ order: {..attributes..} }
  // }
  updateOrder(cb, payload) {
    api.request({
      url: `/agent/orders/${payload.id}`,
      payload: payload.data,
      format: 'PATCH',
    }, cb);
  },



  // Получаем список связей customer_order в JSON.
  // Предполагается, что в payload - {order_id: X}
  getCustomerOrders(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/agent/customer_orders',
      payload: payload,
    }, cb);
  },



  // Получаем список bookings в JSON.
  // Предполагается, что в payload - {order_id: X}
  getOrderBookings(cb, payload) {
    api.request({
      url: `/agent/orders/${payload.order_id}/bookings`
    }, cb)
  },



  // Получаем список hotel_groups в JSON.
  // Предполагается, что в payload - {ids: [12, 45, 56]}
  getHotelGroups(cb, payload) {
    api.request({
      url: '/agent/hotel_groups',
      payload: payload,
    }, cb)
  },



  // Получаем список tour_placement_prices в JSON.
  // Предполагается, что в payload - {ids: [12, 45, 56]}
  getTourPlacementPrices(cb, payload) {
    api.request({
      url: '/agent/tour_placement_prices',
      payload: payload,
    }, cb)
  },



  // Payload is must contain linked attributes
  // {linked_id: X, linked_type: '...'}
  getDocs(payload, cb, cb_fail) {
    if (payload === undefined) payload = {};
    api.request({
      url: `/agent/docs/${payload.linked_type}/${payload.linked_id}`,
    }, cb, cb_fail)
  },



  getMessages(payload, cb, cb_fail) {
    api.request({
      url: `/agent/chats/${payload.chat_id}/messages`,
    }, cb, cb_fail)
  },



  readAllMessages(payload, cb, cb_fail) {
    if (payload === undefined) payload = {};
    api.request({
      url: `/agent/chats/${payload.chat_id}/read_all`,
      format: 'POST',
    }, cb, cb_fail)
  },



  // Create message
  // Payload is must contain message attributes
  // {body: '...', order_id: X, ...}
  createMessage(payload, cb, cb_fail) {
    api.request({
      url: '/agent/messages',
      payload: {message: payload},
      format: 'POST'
    }, cb, cb_fail)
  },



  getAlerts(payload, cb, cb_fail) {
    api.request({
      url: `/agent/alerts`,
    }, cb, cb_fail)
  },



  destroyAlert(payload, cb, cb_fail) {
    api.request({
      url: `/agent/alerts/${payload.id}`,
      format: 'DELETE',
    }, cb, cb_fail)
  },



  // Создаем связь клиент-заказ и получаем её в JSON.
  // payload должен содержать параметры создаваемого объекта
  createCustomerOrder(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/agent/customer_orders',
      payload: {customer_order: payload},
      format: 'POST',
    },cb);
  },



  // Удаляем Связь Клиента с Договором (customer_order) и получаем его в JSON.
  // payload должен содержать id - {id: 1}
  deleteCustomerOrder(cb, payload) {
    if (payload === undefined) payload = {};

    api.request({
      url: '/agent/customer_orders/' + payload.id,
      format: 'DELETE',
    },cb);
  },

}